import { Component, OnInit } from '@angular/core';
import { SignalniLagerService } from './signalnilager.service';
import { moduli } from '../../config';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-signalnilager',
  templateUrl: './signalnilager.component.html',
  styleUrls: ['./signalnilager.component.scss'],
  providers: [SignalniLagerService]
})

export class SignalniLagerComponent implements OnInit {

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');
  sveZalihe: any = [];
  skladistaSirovina: any = [];
  idposlovnica: any = undefined;
  poruka: string;

  sirovine: boolean = false;
  sirovine_vr: any = 0;
  ambalaza: boolean = false;
  ambalaza_vr: any = 0;
  potrosni: boolean = false;
  potrosni_vr: any = 0;
  svaStanja: boolean = false;
  svaStanja_vr: any = 0;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: SignalniLagerService) {

    this.skladistaSirovina = [{ idposlovnica: undefined, po_naziv_prikaz: 'SVE' }];

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().signalniLagerSirovina;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onCellPrepared(e) {
    //console.log(e);
    //console.log(e.rowType);
    //console.log(e.column.dataField);
    if (e.rowType === "data"){
      if(e.column.dataField === "za_stanje" && e.data.za_stanje > e.data.za_maximum){
        e.cellElement.style.fontWeight = "bold";
        e.cellElement.style.color = "red";
      }
      if(e.column.dataField === "za_stanje" && e.data.za_stanje < e.data.za_minimum){
        e.cellElement.style.fontWeight = "bold";
        e.cellElement.style.color = "red"
      }
    }
  }

  dohvatiSkladistaSirovina() {

    let podaciZaSlanje = {
      idfirma: localStorage.getItem('firma'),
      idkorisnik: localStorage.getItem('idsecuser'),
      ambalaza_sirovine_potrosni_pekar: 1
    };
    //console.log(podaciZaSlanje);
    
    this.service.poslovnicaPopis(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.skladistaSirovina = [];
      this.skladistaSirovina = [{ idposlovnica: undefined, sifrainaziv: 'SVE' }];
      if (res.success == true) {
        for (let i = 0; i < res.data.length; i++) {
          this.skladistaSirovina.push({
            idposlovnica: res.data[i].idposlovnica,
            sifrainaziv: res.data[i].sifrainaziv
          });
        }
        //console.log('skladistaSirovina: ', this.skladistaSirovina);
      }
    });
  }

  odabranaGrupa1(e: any){
    //console.log(e);
    if (e.value === true) {
      this.sirovine = true;
      this.sirovine_vr = 1;
    }else{
      this.sirovine = false;
      this.sirovine_vr = 0;
    }
    this.dohvatiZalihe();
  }

  odabranaGrupa2(e: any){
    //console.log(e);
    if (e.value === true) {
      this.ambalaza = true;
      this.ambalaza_vr = 1;
    }else{
      this.ambalaza = false;
      this.ambalaza_vr = 0;
    }
    this.dohvatiZalihe();
  }

  odabranaGrupa3(e: any){
    //console.log(e);
    if (e.value === true) {
      this.potrosni = true;
      this.potrosni_vr = 1;
    }else{
      this.potrosni = false;
      this.potrosni_vr = 0;
    }
    this.dohvatiZalihe();
  }

  prikaziSvaStanja(e: any){
    //console.log(e);
    if (e.value === true) {
      this.svaStanja = true;
      this.svaStanja_vr = 1;
    }else{
      this.svaStanja = false;
      this.svaStanja_vr = 0;
    }
    this.dohvatiZalihe();
  }
  
  promjenaSkladista(e){
    //console.log(e);
    //console.log(e.value);
    this.idposlovnica = e.value;
    this.dohvatiZalihe();
  }

  dohvatiZalihe(){
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      idposlovnica: this.idposlovnica,
      sirovine: this.sirovine_vr,
      ambalaza: this.ambalaza_vr,
      potrosni: this.potrosni_vr,
      svaStanja: this.svaStanja_vr,
    }
    //console.log(podaciZaSlanje);
    this.sveZalihe = [];
    this.poruka = 'Učitavanje...';
    this.service.zalihaPopis(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.sveZalihe = res.data;
      } else {
        
      }
      if (this.sveZalihe.length > 0) {
        this.poruka = 'Učitavanje...';
      } else {
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  urediLager(e){
    //console.log(e);
    //console.log(e.data);
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      za_id: e.data.za_id,
      idartikl: e.data.artikl_ar_id,
      idposlovnica: e.data.poslovnica_po_id,
      za_minimum: e.data.za_minimum,
      za_maximum: e.data.za_maximum
    }
    //console.log(podaciZaSlanje);
    this.service.zalihaUredi(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      if (res.success === true) {
        notify('Uspješno spremljeni podaci.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    })
  }

  ngOnInit(): void {
    this.dohvatiSkladistaSirovina();
    this.dohvatiZalihe();
  }

}
